<!-- a dialog for editing item details -->
<div class="modal-header">
    <h4 class="modal-title">シフト依頼情報の<label>{{currentItem.id!=0?'編集':'登録'}}</label></h4>
  </div>
  <div class="modal-body">
    <fieldset>
      <form  #f="ngForm">
        <div class="form-group row">
            <label for="vcnt" class="col-form-label col-3 lbl-bc">ゴルフ場</label>
            <label for="vcnt" class="col-form-label col-3 lbl-bc">{{currentItem['golf_name']}}</label>
        </div>
        <div class="form-group row">
            <label for="vcnt" class="col-form-label col-3 lbl-bc">種類</label>
            <label for="vcnt" class="col-form-label col-3 lbl-bc">{{currentItem['golfwork_name']}}</label>
        </div>
        <div class="form-group row">
            <label for="vcnt" class="col-form-label col-3 lbl-bc">依頼日</label>
            <label for="vcnt" class="col-form-label col-3 lbl-bc">{{currentItem['ymd']}}</label>
        </div>
        <div class="form-group row">
          <label for="vcnt" class="col-form-label col-3 lbl-bc">ｵﾌｧｰ数</label>
          <div class="col-8">
            <wj-combo-box id="vcnt" name="vcnt" [(ngModel)]="currentItem.cnt" #vpDd="ngModel" [itemsSource]="cnts" [isEditable]="false"></wj-combo-box>
<!--            <input type="text" class="form-control col-3" id="vcnt" name="vcnt" [(ngModel)]="currentItem.cnt" #vcnt="ngModel" (ngModelOptions)="{updateOn: 'blur'}" />
            <span style="color:red" [hidden]="!vcnt.dirty || (!vcnt.errors?.maxlength)">20文字以内で入力してください</span>-->
          </div>
        </div>
        <div class="form-group row">
            <label for="vremarks" class="col-form-label col-3 lbl-bc">備考</label>
            <div class="col-8">
              <wj-combo-box id="vremarks" name="vremarks" [(ngModel)]="currentItem.remarks" #vpDd="ngModel" [itemsSource]="remarkss" [isEditable]="false"></wj-combo-box>
<!--              <input type="text" class="form-control col-12" id="vremarks" name="vremarks" [(ngModel)]="currentItem.remarks" #vremarks="ngModel" (ngModelOptions)="{updateOn: 'blur'}" maxlength="20"/>
              <span style="color:red" [hidden]="!vremarks.dirty || (!vremarks.errors?.maxlength)">20文字以内で入力してください</span>
              -->
            </div>
        </div>
      </form>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button *ngIf="currentItem.id==0" type="button" class="btn btn-primary" [disabled]="!f.form.valid" (click)="regist()"><span class="oi oi-cloud-upload"></span>登録</button>
    <button *ngIf="currentItem.id!=0" type="button" class="btn btn-primary" [disabled]="!f.form.valid" (click)="update()"><span class="oi oi-cloud-upload"></span>更新</button>
    <button type="button" class="btn btn-warning" (click)="activeModal.dismiss('Cross click')"><span class="oi oi-action-undo"></span>キャンセル</button>
  </div>
